import { Component } from '@angular/core';

@Component({
	selector: 'mp-models-screener-dialog-skeleton',
	templateUrl: './models-screener-dialog-skeleton.component.html',
	styleUrls: ['./models-screener-dialog-skeleton.component.scss']
})
export class ModelsScreenerDialogSkeletonComponent {

	public readonly GHOST_ROWS = Array(10).fill(0);

}
